<template>
    <div class='t_content_view'>
        <!-- 搜索 -->
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">设备号：</span>
                <el-input size="small" v-model="searchdata.imei" placeholder="请输入设备号"  clearable />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">wxid：</span>
                <el-input size="small" v-model="searchdata.wxid" placeholder="请输入wxid"  clearable />
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">客服账号：</span>
                <el-select size="small" style="width: 150px;" v-model="searchdata.name" clearable placeholder="请选择">
                    <el-option v-for="item in accountList.data" :key="item.id" :label="item.name" :value="item.name" />
                </el-select>
            </div>
            <div class="t_search_select">
                <span style="color: #6D6D6D;">上线状态：</span>
                <el-select size="small" style="width: 120px;" v-model="searchdata.device_online" clearable placeholder="请选择">
                    <el-option label="在线" :value="1" />
                    <el-option label="离线" :value="0" />
                </el-select>
            </div>
            <el-button @click="searchbtn" style="margin-bottom: 10px;" color="#F1F3F9" type="primary">查询</el-button>
            <!-- <el-button @click="addseat" style="margin-bottom: 10px;" color="#4F46E5" type="primary">添加</el-button> -->
        </div>

        <!-- 坐席列表 -->
        <el-table :header-cell-style="{ background: '#F1F3F9' }" :data="tableData.data" style="width: 100%;margin-top: 20px;">
            <el-table-column prop="id" align="center" label="坐席ID" />
            <el-table-column prop="wx_name" align="center" label="昵称" />
            <el-table-column prop="total_num" align="center" label="客户数">
                <template #default="scope">
                    <div>{{ scope.row.total_num }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="one_way_customer_count" align="center" label="单向客户数" >
                <template #default="scope">
                    <div class="t_customer_num_box">
                        <div>{{ scope.row.one_way_customer_count }}</div>
                        <el-icon class="t_refresh_icon" @click="refreshnum(scope.row)"><Refresh /></el-icon>
                    </div>
                    <div style="color: #999999;font-size: 12px;">{{ scope.row.updated_at }}</div>
                </template>
            </el-table-column>
            <el-table-column prop="true_num" align="center" label="真实好友数" />
            <el-table-column prop="device_online" align="center" label="上线状态">
                <template #default="scope">
                    <span style="color: green;" v-if="scope.row.device_online == '在线'">在线</span>
                    <span style="color: red;" v-else>离线</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="150">
                <template #default="scope">
                    <div style="white-space: nowrap;">
                        <el-button style="color:#4F46E5" size="small" type="text" @click="openInherit(scope.row)">在职继承</el-button>
                        <el-button style="color:#4F46E5" size="small" type="text" @click="openLeave(scope.row)">离职继承</el-button>
                        <el-button style="color:#4F46E5" size="small" type="text" @click="delitem(scope.row)">删除</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagechange :total="total" :nowpage="searchdata.page" @page_change="page_change" />
    </div>

    <!-- 在职继承弹窗 -->
    <el-dialog v-model="isinherit" title="在职继承" width="500px">
        <div class="t_key_dig_con">
            <!-- 当前坐席信息 -->
            <div class="t_inherit_now">
                {{ nowrow.data.wx_name }}账号当前人数：{{ nowrow.data.total_num }}
            </div>
            <!-- 已添加坐席 -->
            <div class="t_inherit_item" v-for="(item, index) in inheritList.data" :key="index">
                <div class="t_inherit_name">{{ item.name }}</div>
                <div class="t_inherit_num_box">
                    <span style="color: #6D6D6D;">继承数量：</span>
                    <el-input-number size="small" :min="1" :max="1000000" v-model="item.num"  clearable />
                </div>
                <div class="t_inherit_del" @click="delInheritSeat(index)">删除</div>
            </div>
            <!-- 添加继承坐席 -->
            <div class="t_inherit_add" style="margin-top: 20px;">
                <span class="t_inherit_label">添加继承坐席：</span>
                <el-select class="t_search_select" size="small" style="width: 200px;margin-bottom: 0;" v-model="chooseSeatId" clearable placeholder="请选择要继承的坐席账号">
                    <el-option v-for="item in dialogAccountList.data" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
                <el-button  @click="addInheritSeat">添加</el-button>
            </div>
            <!-- 提示文字 -->
            <div class="t_inherit_tip">找不到继承坐席，请先在设备上登录该企微账号</div>
        </div>
        <div class="t_dig_btn_box">
            <el-button @click="isinherit = false">取消</el-button>
            <el-button color="#4F46E5" type="primary" @click="submitInherit">确定执行</el-button>
        </div>
    </el-dialog>

    <!-- 离职继承弹窗 -->
    <el-dialog v-model="isleave" title="离职继承" width="500px">
        <div class="t_key_dig_con">
            <div class="t_inherit_add">
                <span class="t_inherit_label">继承坐席：</span>
                <el-select class="t_search_select" size="small" style="flex: 1;margin-bottom: 0;" v-model="leaveSeatId" clearable placeholder="请选择要继承的坐席账号">
                    <el-option v-for="item in dialogAccountList.data" :key="item.id" :label="item.name" :value="item.id" />
                </el-select>
            </div>
            <!-- 提示文字 -->
            <div class="t_inherit_tip">找不到继承坐席，请先在设备上登录</div>
        </div>
        <div class="t_dig_btn_box">
            <el-button @click="isleave = false">取消</el-button>
            <el-button color="#4F46E5" type="primary" @click="submitLeave">确定</el-button>
        </div>
    </el-dialog>
</template>
<script setup>
import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Delete, Edit, Search, Share, Upload, Plus, Close, Refresh } from '@element-plus/icons-vue'
//导入子组件
import pagechange from '../components/pagechange.vue'
import { newgetpeo, newgetneilistnew, newgetonewaycustomernew, newcreateinheritance, newdeleteseat } from '@/assets/js/common.js'

onMounted(() => {
    console.log('onMounted')
    //获取客服账号下拉
    getaccountlist()
    //获取列表
    getlist()
})

//搜索数据
const searchdata = reactive({
    //当前页
    page: 1,
    page_size: 20,
    //企微主体ID
    corp_id: '',
    //在线状态（1在线 0离线）
    device_online: '',
    //设备启用状态
    device_status: '',
    //名称（客服账号昵称）
    name: '',
    //设备号
    imei: '',
    wxid: ''
})
//成员总数
const total = ref(0)

//客服账号下拉数据
const accountList = reactive({
    data: []
})
//获取客服账号下拉数据
const getaccountlist = () => {
    newgetpeo().then((response) => {
        if (response.data.msg.code == 0) {
            accountList.data = response.data.data
        }
    })
}
//继承弹窗内的客服账号下拉数据（按当前行corp_id单独拉取）
const dialogAccountList = reactive({
    data: []
})
//获取继承弹窗内、与当前行同主体下的客服账号下拉
const getdialogaccountlist = (row) => {
    dialogAccountList.data = []
    newgetpeo({ corp_id: row.corp_id }).then((response) => {
        if (response.data.msg.code == 0) {
            dialogAccountList.data = response.data.data
        }
    })
}

//列表数据
const tableData = reactive({
    data: []
})
//获取列表
const getlist = () => {
    newgetneilistnew(searchdata).then((response) => {
        if (response.data.msg.code == 0) {
            tableData.data = response.data.data.data
            total.value = response.data.data.total
        }
    })
}
//查询
const searchbtn = () => {
    searchdata.page = 1
    //获取列表
    getlist()
}
//监听分页
const page_change = (val) => {
    searchdata.page = val
    //获取列表
    getlist()
}
//添加坐席（功能待接入）
const addseat = () => {
    ElMessage({
        message: '添加功能待开发',
        type: 'info',
    })
}
//删除坐席
const delitem = (row) => {
    ElMessageBox.confirm(
        '是否确认删除',
        '提示',
        {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            newdeleteseat({ user_id: row.user_id }).then((response) => {
                if (response.data.msg.code == 0) {
                    ElMessage({
                        message: '删除成功',
                        type: 'success',
                    })
                    //重新获取列表
                    getlist()
                }
            })
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })
}
//刷新客户数
const refreshnum = (row) => {
    newgetonewaycustomernew({
        corp_id: row.corp_id,
        corp_ids: [row.corp_id],
        user_id: row.user_id
    }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '刷新成功，正在更新数据',
                type: 'success',
            })
            //重新获取列表，更新当前这条的数据
            getlist()
        }
    })
}

//是否显示在职继承弹窗
const isinherit = ref(false)
//当前操作的行数据
const nowrow = reactive({
    data: {}
})
//添加坐席选中的id
const chooseSeatId = ref('')
//已添加的继承坐席列表
const inheritList = reactive({
    data: []
})
//打开在职继承弹窗
const openInherit = (row) => {
    nowrow.data = row
    chooseSeatId.value = ''
    inheritList.data = []
    //重新获取与当前行同主体的客服账号下拉
    getdialogaccountlist(row)
    isinherit.value = true
}
//添加继承坐席
const addInheritSeat = () => {
    if (!chooseSeatId.value) {
        ElMessage.error('请先选择坐席账号')
        return
    }
    //查找坐席
    var obj = dialogAccountList.data.find((item) => item.id == chooseSeatId.value)
    if (obj.id == nowrow.data.internal_user_id) {
        ElMessage.error('不能继承给当前坐席本人')
        return
    }
    if (inheritList.data.findIndex((item) => item.id == obj.id) != -1) {
        ElMessage.error('该坐席已添加')
        return
    }
    inheritList.data.push({
        id: obj.id,
        name: obj.name,
        num: 1
    })
    chooseSeatId.value = ''
}
//删除继承坐席
const delInheritSeat = (index) => {
    inheritList.data.splice(index, 1)
}
//提交在职继承
const submitInherit = () => {
    if (inheritList.data.length == 0) {
        ElMessage.error('请先添加继承坐席')
        return
    }
    for (var i = 0; i < inheritList.data.length; i++) {
        if (!inheritList.data[i].num || inheritList.data[i].num < 1) {
            ElMessage.error('请为每个继承坐席填写正确的继承数量')
            return
        }
    }
    var targets = inheritList.data.map((item) => ({
        assigned_count: item.num,
        takeover_internal_user_id: item.id
    }))
    newcreateinheritance({
        inheritance_type: 1,
        corp_id: nowrow.data.corp_id,
        targets: targets,
        transfer_success_msg: '',
        internal_user_id: nowrow.data.internal_user_id,
        idempotency_key: ''
    }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '在职继承操作成功',
                type: 'success',
            })
            isinherit.value = false
            //刷新列表
            getlist()
        }
    })
}

//是否显示离职继承弹窗
const isleave = ref(false)
//离职继承选中的坐席
const leaveSeatId = ref('')
//打开离职继承弹窗
const openLeave = (row) => {
    nowrow.data = row
    leaveSeatId.value = ''
    //重新获取与当前行同主体的客服账号下拉
    getdialogaccountlist(row)
    isleave.value = true
}
//提交离职继承
const submitLeave = () => {
    if (!leaveSeatId.value) {
        ElMessage.error('请先选择坐席账号')
        return
    }
    if (leaveSeatId.value == nowrow.data.internal_user_id) {
        ElMessage.error('不能继承给当前坐席本人')
        return
    }
    newcreateinheritance({
        inheritance_type: 2,
        corp_id: nowrow.data.corp_id,
        targets: [{
            assigned_count: nowrow.data.total_num,
            takeover_internal_user_id: leaveSeatId.value
        }],
        transfer_success_msg: '',
        internal_user_id: nowrow.data.internal_user_id,
        idempotency_key: ''
    }).then((response) => {
        if (response.data.msg.code == 0) {
            ElMessage({
                message: '离职继承操作成功',
                type: 'success',
            })
            isleave.value = false
            //刷新列表
            getlist()
        }
    })
}
</script>
<style scoped>
:deep(.t_search_select .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
    width: 100%;
}
.t_search_select span {
    white-space: nowrap;
    flex-shrink: 0;
}
.t_customer_num_box {
    display: flex;
    align-items: center;
    justify-content: center;
}
.t_refresh_icon {
    margin-left: 6px;
    color: #4F46E5;
    cursor: pointer;
}
.t_inherit_label {
    color: #6D6D6D;
    font-size: 14px;
    margin-right: 12px;
    flex-shrink: 0;
    white-space: nowrap;
    line-height: 24px;
}
.t_inherit_now {
    color: #333333;
    font-size: 14px;
    margin-bottom: 15px;
}
.t_inherit_tip {
    margin-top: 12px;
    color: #999999;
    font-size: 12px;
}
.t_key_dig_con {
    padding: 0px 10px 10px 10px;
    box-sizing: border-box;
}
.t_inherit_item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #F6F8FB;
    border-radius: 8px;
    padding: 10px 15px;
    box-sizing: border-box;
    margin-bottom: 10px;
}
.t_inherit_name {
    color: #333333;
    font-size: 14px;
}
.t_inherit_num_box {
    display: flex;
    align-items: center;
}
.t_inherit_del {
    color: #4F46E5;
    cursor: pointer;
}
.t_inherit_add {
    display: flex;
    align-items: center;
}
.t_inherit_add .el-button {
    margin-left: 12px;
}
.t_dig_btn_box {
    margin-top: 20px;
    display: flex;
    justify-content: end;
}
</style>
